import { Dispatch, FC, SetStateAction, useEffect } from 'react';
import { RELEVANCES } from 'constants/date';
import { useAppSelector } from 'hooks';
import { ILayerQuickFilterSettings } from 'interfaces/localStorage';
import {
  isMapDataLoadedSelector,
  timelineTypesSelector,
} from 'store/slices/mapV2/tabsReducer/layersReducer/stateSlice/selectors';
import { TDateRange } from 'types';

import { getDateRangeFromRelevance, useLocalStorageDates } from 'utils';
import { useLayerQuickFilterLocalStorage } from 'utils/localStorage';

import { CreatedAtFilter } from '../types';

import { DateFilterSelector } from './DateFilterSelector';

const initialQuickFilterSettings: ILayerQuickFilterSettings = {
  relevance: RELEVANCES.THREE_DAYS,
  startDate: null,
  endDate: null,
};

interface QuickFiltersProps {
  onCreatedAtFilterChange: (createdAtFilter: CreatedAtFilter) => void;
  handleFilterSetup?: (createFilter: TDateRange) => void;
  areFiltersSetup?: boolean;
  setAreFiltersSetup?: Dispatch<SetStateAction<boolean>>;
}

export const QuickFilters: FC<QuickFiltersProps> = ({
  onCreatedAtFilterChange,
  handleFilterSetup,
  areFiltersSetup,
  setAreFiltersSetup,
}) => {
  const [quickFilterSettings, setQuickFilterSettings] =
    useLayerQuickFilterLocalStorage(initialQuickFilterSettings);
  const localStorageDates = useLocalStorageDates(quickFilterSettings);

  const { objects: isTimeline } = useAppSelector(timelineTypesSelector);
  const mapDataLoaded = useAppSelector(isMapDataLoadedSelector);

  const { relevance } = quickFilterSettings;
  const [startDate, endDate] = localStorageDates;

  useEffect(() => {
    if (!areFiltersSetup && mapDataLoaded) {
      if (relevance !== RELEVANCES.OTHER) {
        const properDateRange = getDateRangeFromRelevance(relevance);

        setQuickFilterSettings({
          ...quickFilterSettings,
          startDate: properDateRange?.at(0) ?? startDate,
          endDate: properDateRange?.at(1) ?? endDate,
        });
        handleFilterSetup?.(properDateRange ?? localStorageDates);
      } else {
        handleFilterSetup?.(localStorageDates);
      }

      setAreFiltersSetup?.(true);
    }
  }, [mapDataLoaded]);

  return (
    <div className="px-4 w-full h-13 pt-4 pb-2 flex flex-row gap-1 tpg-c2 text-tpg_base">
      <p>ЦЕЛИ</p>
      <DateFilterSelector
        filterSettings={quickFilterSettings}
        setFilterSettings={setQuickFilterSettings}
        onCreatedAtFilterChange={onCreatedAtFilterChange}
        disabled={isTimeline}
      />
    </div>
  );
};
